import { Globals } from "../CoreApp/Globals";

export function appstrp(strCode, plus) {
  //return "{" + gStringMgr.appstr(strCode) + plus +  "}";
  return Globals._stringMgr.appstr(strCode) + plus;
}
